import { Link } from 'react-router-dom'
import { ArticleTag } from '../HomePage/ArticleTag'
import {
  images,
  postListImages,
  postListNewImages,
} from '../../services/images.service'
import { PostAuthorLine } from './PostAuthorLine'
import { GreyDivider } from '../ui/elements'
import { HeartIcon } from '../ui/icons/shared'

export function MostLikedPost({ posts, authorMap }) {
  if (!posts || posts.length === 0) return null

  const sortedPosts = [...posts].sort((a, b) => b.likes.length - a.likes.length)
  const mostLikedPost = sortedPosts[0]
  const sortedPostsByDate = [...posts].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  )
  const latestPosts = sortedPostsByDate.slice(0, 4)

  if (!mostLikedPost) return null

  return (
    <section className="container mx-auto">
      <h2 className="mb-4 text-2xl">הכתבה המובילה באתר</h2>
      <div className="grid lg:grid-cols-[70%_30%] gap-8">
        {/* פוסט מוביל */}
        <div
          className="relative max-h-[600px] overflow-hidden"
          style={{
            borderImage: `url(${images.redBorder}) 10 stretch`,
            borderWidth: '2px',
            borderStyle: 'solid',
          }}
        >
          <img
            src={mostLikedPost.imageUrl}
            alt={mostLikedPost.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 flex flex-col justify-end lg:w-[60%]">
            <div
              className="relative w-full bg-no-repeat bg-cover"
              style={{ backgroundImage: `url(${postListImages.popularBlock})` }}
            >
              <div className="flex flex-col gap-4 p-4">
                <ArticleTag tags={mostLikedPost.tags} />
                <div className="w-[70%]">
                  <Link to={`/post/${mostLikedPost._id}`}>
                    <h2 className="text-xl lg:text-3xl text-white">
                      {mostLikedPost.title}
                    </h2>
                  </Link>
                  <p className="hidden lg:block text-softText">
                    {mostLikedPost.description}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <HeartIcon />
                  <span className="text-white">
                    {mostLikedPost.likes.length}
                  </span>
                </div>
                <PostAuthorLine
                  userId={mostLikedPost.author?.userId}
                  createdAt={mostLikedPost.createdAt}
                />
              </div>
            </div>
          </div>
        </div>

        {/* פוסטים חדשים */}
        <div>
          <div
            className="relative w-full bg-no-repeat bg-cover h-12 flex items-center p-2"
            style={{ backgroundImage: `url(${postListNewImages.blockBanner})` }}
          >
            <div className="flex gap-2">
              <img src={postListNewImages.blockIcon} alt="Icon" />
              <h1 className="text-xl">כתבות חדשות</h1>
            </div>
          </div>

          {latestPosts.map((post) => {
            return (
              <div key={post._id} className="flex flex-col gap-2">
                <Link to={`/post/${post._id}`}>
                  <div className="flex gap-4 items-start mt-4">
                    <img
                      className="w-16 h-16 object-cover"
                      src={post.imageUrl}
                      alt={post.title}
                    />
                    <div className="flex flex-col gap-1 max-w-[300px]">
                      <h5 className="font-yarden text-white text-lg leading-tight">
                        {post.title}
                      </h5>
                      <PostAuthorLine
                        userId={post.author?.userId}
                        createdAt={post.createdAt}
                      />
                    </div>
                  </div>
                </Link>
                <GreyDivider className="lg:my-7" />
              </div>
            )
          })}
        </div>
      </div>

      {/* <GreyDivider className="my-24"/> */}
    </section>
  )
}
